import type { Messages } from "../../catalog";

export const modulesMessages = {
  "Close (price)": "Close",
  "Open (price)": "Open",
  "{count} contributions": { one: "{count} contribution", other: "{count} contributions" },
  "{count} people": { one: "{count} person", other: "{count} people" },
  "{count} sessions": { one: "{count} session", other: "{count} sessions" },
  "{count} Tasks": { one: "{count} Task", other: "{count} Tasks" },
} satisfies Messages;
